export default "__VITE_ASSET__jYt4e28q__"